export const transformString = (str) => {
  // Handle non-string inputs safely
  if (str === null || str === undefined) {
    return "N/A";
  }

  // Handle arrays - return the array itself to be processed as tags
  if (Array.isArray(str)) {
    return str;
  }

  // Convert to string if it's not already a string
  const stringValue = String(str);

  return stringValue
    .split("_") // Split the string by underscores
    .map((word) => word.charAt(0).toUpperCase() + word.slice(1)) // Capitalize each word
    .join(" "); // Join the words with spaces
};

export const transformStringForDash = (str) => {
  // Handle non-string inputs safely
  if (str === null || str === undefined) {
    return "N/A";
  }

  // Handle arrays - return the array itself to be processed as tags
  if (Array.isArray(str)) {
    return str;
  }

  // Convert to string if it's not already a string
  const stringValue = String(str);

  return stringValue
    .split("-") // Split the string by dashes
    .map((word) => word.charAt(0).toUpperCase() + word.slice(1)) // Capitalize each word
    .join(" "); // Join the words with spaces
};
